import {Component, OnInit, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import {PortaluserService} from 'src/app/_services/portaluser.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {ToastrService} from 'ngx-toastr';
import {PortaluserAddComponent} from '../portaluser-add/portaluser-add.component';
import {PortalUserRequest} from 'src/app/_model/request/PortalUserRequest';
import {PortalUserSearchRequest} from 'src/app/_model/request/PortalUserSearchRequest';
import {PortaluserDeleteComponent} from '../portaluser-delete/portaluser-delete.component';
import {AuthenticationService} from 'src/app/_services/authentication.service';
import {User} from 'src/app/_model/user';
import {UtilsService} from '../../_services/utils.service';


@Component({
    selector: 'app-portaluser-list',
    templateUrl: './portaluser-list.component.html',
    styleUrls: ['./portaluser-list.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatRadioModule
    ]
})
export class PortaluserListComponent implements OnInit {
    @ViewChild('userPaginator', {static: false}) paginator: MatPaginator;
    displayedColumns: string[] = ['employeename', 'username', 'email', 'actions'];
    dataSource: MatTableDataSource<any>;
    selectedPortalUser: PortalUserRequest;
    currentUser: User;
    filterValue = null;
    activeUsers: any[];
    activeList: any[] = [{description: 'Aktif', value: 1,}, {description: 'Pasif', value: 0}];
    activeFilter: number = this.activeList[0].value;

    // Pagination Variables
    size = 10;
    pageNumber = 0;
    // Filter Variables
    filterName = '';
    filterSurname = '';
    active = 1;


    paginatorIntl = new MatPaginatorIntl();
    
    portalUserSearchRequest: PortalUserSearchRequest = new PortalUserSearchRequest
    (this.pageNumber, this.size, this.filterName, this.filterSurname, this.active);

    constructor(private portalUserService: PortaluserService,
                private toastr: ToastrService,
                private authService: AuthenticationService,
                public dialog: MatDialog,
                public utilsService: UtilsService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
        this.loadActiveUsers();
        this.paginatorIntl.itemsPerPageLabel = 'Satır sayısı';
        this.paginatorIntl.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
            return 'Kayıt bulunamadı' ;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
            return length + ' Kayıttan ' + (startIndex + 1) + ' - ' + endIndex + ' arası ' ;
        };
    }

    loadActiveUsers() {
        this.portalUserService.listActiveUsers(this.portalUserSearchRequest).subscribe(
            result => {
                this.activeUsers = result.responseData.items;
                this.activeUsers.forEach(element => {
                    if (element.employee != undefined) {
                        element.employeename = element.employee.name + ' ' + element.employee.surname;
                    } else {
                        element.employeename = '';
                    }
                });

                this.dataSource = new MatTableDataSource(result.responseData.items);
                this.paginator.length = result.totalCount;
                this.paginator.pageIndex = this.portalUserSearchRequest.pageNumber;
                this.paginator.pageSize = this.portalUserSearchRequest.size;
                this.paginator._intl = this.paginatorIntl;


            });
    }


    openCreateModal() {
        this.dataSource.filter = null;
        const dialogRef = this.dialog.open(PortaluserAddComponent, {
            width: '650px',
            height: 'auto',
            data: {}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (result.data.employee != undefined) {
                    result.data.employeename = result.data.employee.name + ' ' + result.data.employee.surname;
                } else {
                    result.data.employeename = '';
                }
                this.dataSource.data.push(result.data);
                this.dataSource._updateChangeSubscription();
                // this.employeeListTable.renderRows();
            }
            if (this.filterValue != null) {
                this.dataSource.filter = this.filterValue.trim().toLowerCase();
            }
        });
    }

    openUpdateModal(portaluser) {
        this.selectedPortalUser = portaluser;

        const dialogRef = this.dialog.open(PortaluserAddComponent, {
            width: '650px',
            height: 'auto',
            data: portaluser
        });
        this.dataSource.filter = null;

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const portaluserIndex = this.dataSource.data.findIndex(port => port.id === result.data.id);
                if (result.data.employee != undefined) {
                    result.data.employeename = result.data.employee.name + ' ' + result.data.employee.surname;
                } else {
                    result.data.employeename = '';
                }
                this.dataSource.data.splice(portaluserIndex, 1, result.data);
                this.dataSource._updateChangeSubscription();
            }
            if (this.filterValue != null) {
                this.dataSource.filter = this.filterValue.trim().toLowerCase();
            }
        });
    }

    openDeleteModal(portaluser: PortalUserRequest) {

        this.dataSource.filter = null;
        this.selectedPortalUser = portaluser;

        const dialogRef = this.dialog.open(PortaluserDeleteComponent, {
            width: '300px',
            data: portaluser
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const portaluserIndex = this.dataSource.data.findIndex(port => port.id === result.data.id);
                this.dataSource.data.splice(portaluserIndex, 1);
                this.dataSource._updateChangeSubscription();
            }
            if (this.filterValue != null) {
                this.dataSource.filter = this.filterValue.trim().toLowerCase();
            }
        });
    }


    filterGrid() {
        this.portalUserSearchRequest.active = this.activeFilter;
        this.portalUserSearchRequest.name = this.filterName;
        this.portalUserSearchRequest.surname = this.filterSurname;
        this.loadActiveUsers();

    }

    clearFilterGrid() {
        this.filterName = '';
        this.filterSurname = '';
        this.activeFilter = 1;
        this.filterGrid();
    }

    UserPageEvent(pageEvent: PageEvent) {
        this.portalUserSearchRequest.size = pageEvent.pageSize;
        this.portalUserSearchRequest.pageNumber = pageEvent.pageIndex;
        this.loadActiveUsers();
    }

}
